import type { SVGProps } from "react";
const SvgMessage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    fontSize="1rem"
    {...props}
  >
    <path
      stroke="#FF073B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.455}
      d="M20.185 11.545a7.6 7.6 0 0 1-.818 3.456 7.73 7.73 0 0 1-6.912 4.275 7.6 7.6 0 0 1-3.456-.819l-5.184 1.728 1.728-5.184a7.6 7.6 0 0 1-.819-3.456A7.73 7.73 0 0 1 9 4.633a7.6 7.6 0 0 1 3.456-.818h.454a7.71 7.71 0 0 1 7.276 7.276z"
    />
  </svg>
);
export default SvgMessage;
